import React, { useEffect } from 'react'
import { Router, globalHistory, navigate } from '@reach/router'
import LazyComponent from './components/LazyComponent/LazyComponent'
import PerfilRoutes from './containers/Perfil/rotas'
import ModalidadeRoutes from './containers/Modalidade/rotas'
import BooksterRoutes from './containers/Bookster/rotas'
import PaginaNaoEncontrada from './containers/PaginaNaoEncontrada/PaginaNaoEncontrada'
import { ModalidadeProvider } from './contexts/ModalidadeContext'
import { MODALIDADE } from './containers/Modalidade/constants'
import { ROUTE_BASEPATH, URLS } from './constants'
import { MeusKitsProvider } from './contexts/MeusKitsContext'
import { AssociadoProvider } from './contexts/AssociadoContext'
import { AssinaturaPresenteProvider } from './contexts/AssinaturaPresenteContext'

import MeusKits from './containers/MeusKits'
import Home from './containers/Home/home'
import Login from './containers/Login/Login'
import Logout from './containers/Login/Logout'
import EsqueciMinhaSenha from './containers/EsqueciMinhaSenha/EsqueciMinhaSenha'
import RedefinirSenha from './containers/RedefinirSenha/RedefinirSenha'
import AssinaturaPresente from './containers/AssinaturaPresente/AssinaturaPresente'
import Resgate from './containers/AssinaturaPresente/Resgate/Resgate'
import SetupAssinatura from './containers/SetupAssinatura/SetupAssinatura'
import SetupAssinaturaEscolhaClube from './containers/SetupAssinaturaEscolhaClube/SetupAssinaturaEscolhaClube'

export default function Rotas() {
  const prevState = []

  function addToState( href ) {
    prevState.push( href )
  }

  useEffect( () => {
    globalHistory.listen( obj => {
      if ( obj.action === 'PUSH' ) {
        const { pathname } = obj.location
        if ( pathname ) {
          addToState( pathname )
        }
      }
      if ( obj.action === 'POP' ) {
        navigate( `${prevState[ prevState.length - 1 ]}` )
      }
    } )
  }, [ ] )

  return (
    <Router basepath={ ROUTE_BASEPATH }>
      <PaginaNaoEncontrada path="*" />

      <LazyComponent
        Component={ Home }
        currentRoute={ URLS.HOME }
        path="/"
      />

      <LazyComponent
        Component={ Home }
        currentRoute={ URLS.HOME }
        path="/home/*"
      />

      <LazyComponent
        Component={ SetupAssinatura }
        Context={ AssociadoProvider }
        currentRoute={ URLS.SETUP_ASSINATURA }
        path={ `/${URLS.SETUP_ASSINATURA}` }
      />

      <LazyComponent
        Component={ SetupAssinaturaEscolhaClube }
        Context={ AssociadoProvider }
        currentRoute={ URLS.SETUP_ASSINATURA_ESCOLHA_CLUBE }
        path={ `/${URLS.SETUP_ASSINATURA_ESCOLHA_CLUBE}` }
      />

      <LazyComponent
        Component={ ModalidadeRoutes }
        Context={ ModalidadeProvider }
        modalidadeDaRota={ MODALIDADE.CURADORIA }
        path="/curadoria/*"
      />

      <LazyComponent
        Component={ ModalidadeRoutes }
        Context={ ModalidadeProvider }
        modalidadeDaRota={ MODALIDADE.INEDITOS }
        path="/ineditos/*"
      />

      <LazyComponent
        Component={ BooksterRoutes }
        currentRoute={ URLS.BOOKSTER }
        path={ `/${URLS.BOOKSTER}/*` }
        requerBookster
      />

      <LazyComponent
        Component={ MeusKits }
        Context={ MeusKitsProvider }
        currentRoute={ URLS.MEUS_KITS }
        path={ `/${URLS.MEUS_KITS}` }
      />

      <LazyComponent
        Component={ Login }
        currentRoute={ URLS.LOGIN }
        path={ `/${URLS.LOGIN}` }
      />

      <LazyComponent
        Component={ Logout }
        currentRoute={ URLS.LOGOUT }
        path={ `/${URLS.LOGOUT}` }
      />

      <LazyComponent
        Component={ EsqueciMinhaSenha }
        Context={ AssociadoProvider }
        currentRoute={ URLS.ESQUECI_MINHA_SENHA }
        isRotaProtegida={ false }
        path={ `/${URLS.ESQUECI_MINHA_SENHA}` }
      />

      <LazyComponent
        Component={ RedefinirSenha }
        Context={ AssociadoProvider }
        currentRoute={ URLS.REDEFINIR_SENHA }
        isRotaProtegida={ false }
        path={ `/${URLS.REDEFINIR_SENHA}` }
      />

      <LazyComponent
        Component={ AssinaturaPresente }
        currentRoute={ URLS.ASSINATURA_PRESENTE }
        path={ `/${URLS.ASSINATURA_PRESENTE}` }
      />

      <LazyComponent
        Component={ Resgate }
        Context={ AssinaturaPresenteProvider }
        currentRoute={ URLS.ASSINATURA_PRESENTE_RESGATE }
        path={ `/${URLS.ASSINATURA_PRESENTE_RESGATE}` }
      />

      <PerfilRoutes path="/perfil" />
    </Router>
  )
}
